<template>
  <section class="home-about" id="about">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-6" data-aos="fade-right" data-aos-duration="1000">
          <div class="about-images">
            <div class="img-main">
              <img src="https://images.unsplash.com/photo-1551504734-5ee1c4a1479b?auto=format&fit=crop&w=600&q=80" alt="Tacos" />
            </div>
            <div class="img-secondary">
              <img src="https://images.unsplash.com/photo-1599974579688-8dbdd335c77f?auto=format&fit=crop&w=400&q=80" alt="Bowl" />
            </div>
            <div class="experience-badge">
              <span class="number">20+</span>
              <span class="label">Years of<br/>Experience</span>
            </div>
          </div>
        </div>
        <div class="col-lg-6" data-aos="fade-left" data-aos-duration="1000" data-aos-delay="200">
          <div class="about-content">
            <span class="section-tag">
              <i class="ri-heart-3-line"></i> Our Story
            </span>
            <h2>The Art of<br/><span class="text-accent">Halal Mexican</span> Cuisine</h2>
            <p class="lead-text">
              At Guac & Grill, we are passionate about bringing authentic Mexican cuisine 
              to our community — made entirely with Zabiha halal meats and the freshest ingredients.
            </p>
            <p>
              Our journey began over 20 years ago when our founders immigrated to the 
              United States and started working in various Mexican restaurants. They eventually 
              saved enough to open their first restaurant, and Guac & Grill was born — filling 
              a gap in the market for halal-certified Mexican food that doesn't compromise on 
              authenticity or flavor.
            </p>
            <div class="about-features">
              <div class="feature-item">
                <div class="feature-icon">
                  <i class="ri-shield-check-line"></i>
                </div>
                <div>
                  <h4>Zabiha Halal Certified</h4>
                  <p>All meats are 100% Zabiha halal sourced</p>
                </div>
              </div>
              <div class="feature-item">
                <div class="feature-icon">
                  <i class="ri-leaf-line"></i>
                </div>
                <div>
                  <h4>Fresh & Antibiotic-Free</h4>
                  <p>Antibiotic-free produce, made fresh daily</p>
                </div>
              </div>
              <div class="feature-item">
                <div class="feature-icon">
                  <i class="ri-group-line"></i>
                </div>
                <div>
                  <h4>Family Friendly</h4>
                  <p>Casual, welcoming atmosphere for everyone</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "HomeAbout",
});
</script>

<style lang="scss" scoped>
.home-about {
  padding: 120px 0;
  background: #0f0f0f;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: -200px;
    right: -200px;
    width: 500px;
    height: 500px;
    background: radial-gradient(circle, rgba(181, 255, 0, 0.04) 0%, transparent 70%);
    border-radius: 50%;
  }

  .about-images {
    position: relative;
    padding: 20px;

    .img-main {
      border-radius: 20px;
      overflow: hidden;
      box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
      img {
        width: 100%;
        height: 420px;
        object-fit: cover;
        display: block;
        transition: transform 0.6s ease;
        &:hover {
          transform: scale(1.03);
        }
      }
    }

    .img-secondary {
      position: absolute;
      bottom: -20px;
      right: -20px;
      width: 200px;
      height: 200px;
      border-radius: 16px;
      overflow: hidden;
      border: 4px solid #0f0f0f;
      box-shadow: 0 12px 40px rgba(0, 0, 0, 0.6);
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .experience-badge {
      position: absolute;
      top: 0;
      left: 0;
      background: #b5ff00;
      border-radius: 16px;
      padding: 20px 24px;
      text-align: center;
      box-shadow: 0 8px 30px rgba(181, 255, 0, 0.3);
      .number {
        display: block;
        font-size: 36px;
        font-weight: 800;
        color: #0a0a0a;
        line-height: 1;
      }
      .label {
        font-size: 12px;
        font-weight: 600;
        color: #0a0a0a;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        line-height: 1.3;
      }
    }
  }

  .about-content {
    padding-left: 40px;

    .section-tag {
      display: inline-flex;
      align-items: center;
      gap: 8px;
      color: #b5ff00;
      font-size: 13px;
      font-weight: 600;
      letter-spacing: 1.5px;
      text-transform: uppercase;
      margin-bottom: 20px;
      i {
        font-size: 16px;
      }
    }

    h2 {
      font-size: 44px;
      font-weight: 800;
      color: #ffffff;
      line-height: 1.15;
      margin-bottom: 24px;
      letter-spacing: -1px;
      .text-accent {
        color: #b5ff00;
      }
    }

    .lead-text {
      font-size: 17px;
      color: rgba(255, 255, 255, 0.75);
      line-height: 1.7;
      margin-bottom: 16px;
    }

    p {
      font-size: 15px;
      color: rgba(255, 255, 255, 0.55);
      line-height: 1.7;
      margin-bottom: 32px;
    }

    .about-features {
      display: flex;
      flex-direction: column;
      gap: 20px;

      .feature-item {
        display: flex;
        align-items: flex-start;
        gap: 16px;

        .feature-icon {
          width: 48px;
          height: 48px;
          min-width: 48px;
          background: rgba(181, 255, 0, 0.1);
          border: 1px solid rgba(181, 255, 0, 0.2);
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          i {
            font-size: 22px;
            color: #b5ff00;
          }
        }

        h4 {
          font-size: 16px;
          font-weight: 700;
          color: #ffffff;
          margin-bottom: 4px;
        }

        p {
          font-size: 14px;
          color: rgba(255, 255, 255, 0.5);
          margin-bottom: 0;
          line-height: 1.4;
        }
      }
    }
  }
}

@media (max-width: 991px) {
  .home-about {
    padding: 80px 0;

    .about-images {
      margin-bottom: 60px;
    }

    .about-content {
      padding-left: 0;
      h2 {
        font-size: 34px;
      }
    }
  }
}
</style>
